export default __webpack_public_path__ + "static/media/star.1fbac286.png";